import { ListingModalRef } from "components/ButtonModal";
import { RefObject } from "react";
import TextFieldWithLimit from "components/text-fields/TextFieldWithLimit";
import { useMasterArtworkPrintingTechniqueStore } from "../../../../context/MasterArtworkPrintingTechniqueContext";
import { MasterArtworkPrintingTechniqueActions } from "../../../../states/meta-artwork/printing-technique";

const ApproveConfirmationModal = ({
  onConfirm,
  parentModalRef,
}: {
  onConfirm: (...args: any) => any;
  parentModalRef: RefObject<ListingModalRef>;
}) => {
  const { state, dispatch } = useMasterArtworkPrintingTechniqueStore();

  const handleSubmitComment = (item: any) => {
    dispatch(
      MasterArtworkPrintingTechniqueActions.setApproveComment(
        item.target.value,
      ),
    );
  };

  return (
    <div className="d-flex flex-column" style={{ minHeight: 250 }}>
      <span className="my-2 text-center black-text">
        Before submit to approval you can leave a useful comment about this
        request <strong>(optional)</strong>
      </span>
      <div className="row">
        <TextFieldWithLimit
          spacing="col-12"
          label="Comment"
          limit={1000}
          value={state.approveComment}
          onChange={handleSubmitComment}
          invalidMessage="The comment must have a maximum of 1000 characters"
        />
      </div>
      <div className="d-flex justify-content-end mt-auto gap-3">
        <input
          type="submit"
          onClick={parentModalRef.current?.closeModal}
          className="btn btn-secondary"
          value={"Cancel"}
        />

        <input
          type="submit"
          onClick={onConfirm}
          className="btn btn-primary"
          value={"Approve"}
          disabled={state.approveComment.length > 1000}
        />
      </div>
    </div>
  );
};

export default ApproveConfirmationModal;
